import { AIChatBlockSchema } from '@affine/core/blocksuite/ai/blocks/ai-chat-block/model';
import { TranscriptionBlockSchema } from '@affine/core/blocksuite/ai/blocks/transcription-block/model';
import { AffineSchemas } from '@blocksuite/affine/schemas';
import { Schema } from '@blocksuite/affine/store';
import {
  AutomationBlockSchema,
  ElsterBlockSchema,
  GhostBlockSchema,
  TrashcanBlockSchema,
  TutorialCardBlockSchema,
} from '@blocksuite/affine-block-streamlain';

let _schema: Schema | null = null;
export function getStreamLainWorkspaceSchema() {
  if (!_schema) {
    _schema = new Schema();

    _schema.register([
      ...AffineSchemas,
      AIChatBlockSchema,
      TranscriptionBlockSchema,
      AutomationBlockSchema,
      ElsterBlockSchema,
      GhostBlockSchema,
      TrashcanBlockSchema,
      TutorialCardBlockSchema,
    ]);
  }

  return _schema;
}
